import React from 'react';

interface IconCheckCircleProps {
    iconClasses?: string;
}

const IconCheckCircle: React.FC<IconCheckCircleProps> = ({ iconClasses }) => {
    return (
        <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-check-circle ${iconClasses ?? ''}`}
            aria-hidden="true"
        >
            <path
                d="M11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0ZM11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2ZM16.3135 8.24219L9.24219 15.3135L5 11.0713L6.41406 9.65723L9.24219 12.4854L14.8994 6.82812L16.3135 8.24219Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconCheckCircle;
